@if (loading) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" [disabled]="saveDisabled" (onSaveClick)="save()" (onCancelClick)="cancel()"
                               [displayNotification]="showDREMsg" [notifMsg]="DREMsg">
</dst-create-disclosure-actions>

<div class="form-template-wrapper li-apdix-wrapper-temp" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form236">
    <dst-template-header [parentFormGroup]="form236" (consolGroupChanged)="onConsolGroupChanged($event)">
    </dst-template-header>

    <div class="mt-3" formGroupName="sec0">
      <dst-template-leid-selector class="required-field" [label]="'Please specify the LEID of the Shareholder'"
                                  [labelId]="'1'" (onSelectedLEChanged)="onShareholderChanged($event)">
      </dst-template-leid-selector>

      <div class="entity-details">
        <span class="ed-label">Entity Name:</span>
        <span class="template-color-blue">{{!shareholder ? '' : shareholder.ENTITY}}</span>
      </div>
      <div class="entity-details">
        <span class="ed-label">Federal ID:</span>
        <span class="template-color-blue">{{!shareholder ? '' : (shareholder.EIN ? shareholder.EIN : 'N/A')}}</span>
      </div>

      @if (shareholder && shareholder.EIN === undefined) {
<div class="entity-details">
        <span class="ed-label">EIN Missing Reason:</span>
        <div class="d-inline-block">
          <ap-dropdown class="ap-form-field-my-wrapper" [list]="reasonsEIN[0]?.data || []" [selectType]="'single'" [title]="'EIN Missing Reason'" [inputAriaLabel]="'EIN Missing Reason'"
                       [optionName]="'text'"
                       [(ngModel)]="selectedSHEINReasonItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                       (onSelect)="onSHEINMissingReasonChanged($event)" [required]="true">
            @for (item of reasonsEIN[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
              [optionName]="'text'"
              [ariaLabel]="setAriaLabel(item, 'EIN Missing Reason')"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
          </ap-dropdown>
        </div>
      </div>
}

      <div class="row mt-4">
        <div class="col-md-12">Shareholder Tax Year</div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ap-radio-group [ariaLabel]="'Shareholder Tax Year'">
                  <ap-radio [styleClass]="'a-mx-10'" [value]="'Year'" [(ngModel)]="shareholderTaxYearType" [ngModelOptions]="{standalone: true}" [name]="'radio-group-1'" (onChange)="check1($event, 'Year')">
            <span>Specify By Calendar Year</span>
          </ap-radio>
                  <ap-radio [styleClass]="'a-mx-10'" [value]="'Range'" [(ngModel)]="shareholderTaxYearType" [ngModelOptions]="{standalone: true}" [name]="'radio-group-1'" (onChange)="check1($event, 'Range')">
            <span>Specify By Date Range</span>
          </ap-radio>
                </ap-radio-group>
        </div>
      </div>
      @if (shareholderTaxYearType === 'Year') {
<div class="row">
        <div class="col-md-12">
          <div class="entity-details">
            <span class="mt-2 ml-3" style="width: 265px;">Calendar Year</span>
            <div class="d-inline-block">
              <ap-dropdown class="ap-form-field-my-wrapper field-full-width select-dropdown"
                           [list]="taxYearsSH[0]?.data || []" [selectType]="'single'" [showSearchbox]="true" [title]="'Tax Year'" [inputAriaLabel]="'Tax Year'"
                           [optionName]="'text'"
                           [(ngModel)]="selectedSHTaxYearItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                           (onSelect)="onShareholderTYChanged($event)">
                @for (item of taxYearsSH[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                  [optionName]="'text'"
                  [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
              </ap-dropdown>
            </div>
          </div>
        </div>
      </div>
}
      @if (shareholderTaxYearType === 'Range') {
<div class="row ap-form-field-my-wrapper mt-1">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="entity-details">
                <span style="width: 260px;">Tax Year Beginning</span>
                <div class="d-inline-block">
                <app-date-picker-with-clear
                  class="date-field date-field-margin"
                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="''"
                  [required]="false"
                  (dateChange)="dateChange($event, 2)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(2)"
                  [(ngModel)]="shareholderBeginningTY"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="entity-details">
                <span style="width: 260px;">Tax Year Ending</span>
                <div class="d-inline-block">
                <app-date-picker-with-clear
                  class="date-field date-field-margin"
                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="''"
                  [required]="false"
                  (dateChange)="dateChange($event, 3)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(3)"
                  [(ngModel)]="shareholderEndingTY"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
}

      <div class="row mt-3">
        <div class="col-md-12">
          Check type of shareholder filing the return:
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <ap-checkbox [styleClass]="'a-mx-10'" (onChange)="onShareholderTypeChecked($event, 'Individual')"
                       [ngModel]="shareholderFiling === 'Individual'" [ngModelOptions]="{standalone: true}">
            <span>Individual</span>
          </ap-checkbox>
        </div>
        <div class="col-md-2">
          <ap-checkbox [styleClass]="'a-mx-10'" (onChange)="onShareholderTypeChecked($event, 'Corporation')"
                       [ngModel]="shareholderFiling === 'Corporation'" [ngModelOptions]="{standalone: true}">
            <span>Corporation</span>
          </ap-checkbox>
        </div>
        <div class="col-md-2">
          <ap-checkbox [styleClass]="'a-mx-10'" (onChange)="onShareholderTypeChecked($event, 'Partnership')"
                       [ngModel]="shareholderFiling === 'Partnership'" [ngModelOptions]="{standalone: true}">
            <span>Partnership</span>
          </ap-checkbox>
        </div>
        <div class="col-md-2">
          <ap-checkbox [styleClass]="'a-mx-10'" (onChange)="onShareholderTypeChecked($event, 'SCorporation')"
                       [ngModel]="shareholderFiling === 'SCorporation'" [ngModelOptions]="{standalone: true}">
            <span>S Corporation</span>
          </ap-checkbox>
        </div>
        <div class="col-md-2">
          <ap-checkbox [styleClass]="'a-mx-10'" [ngModel]="shareholderFiling === 'NongrantorTrust'" [ngModelOptions]="{standalone: true}"
                       (onChange)="onShareholderTypeChecked($event, 'NongrantorTrust')">
            <span>Nongrantor Trust</span>
          </ap-checkbox>
        </div>
        <div class="col-md-2">
          <ap-checkbox [styleClass]="'a-mx-10'" (onChange)="onShareholderTypeChecked($event, 'Estate')"
                       [ngModel]="shareholderFiling === 'Estate'" [ngModelOptions]="{standalone: true}">
            <span>Estate</span>
          </ap-checkbox>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12">
          <div class="d-flex">
            <div>
              Qualifying Insurance Corporation Election - I, a shareholder of stock of a foreign corporation, elect to treat such stock as the stock of a
              Qualifying Insurance Corporation under the alternative facts and circumstances test within the meaning of section 1297(f)(2). See instructions
              <span class="Appkit4-icon icon-information-fill red-icon" ap-tooltip [tooltipContent]="tooltip1" [direction]="'right'" [tooltipId]="'form8621-insurance-corp-info'" ariaDescribedby="form8621-insurance-corp-info"></span>
            </div>
            <ap-checkbox [styleClass]="'a-mx-10'" [(ngModel)]="corpElectionChecked" [ngModelOptions]="{standalone: true}" (onChange)="onCorpElectionChecked($event)">
            </ap-checkbox>
          </div>
        </div>
      </div>

      <!-- PFIC Information -->
      <div class="row mt-4">
        <div class="col-md-3">
          <span>Is PFIC in Legal Entity Database?</span>
        </div>
        <div class="col-md-3">
          <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [styleClass]="'a-mx-10'" [value]="'Yes'" [(ngModel)]="isPFICInDB" [ngModelOptions]="{standalone: true}" [name]="'radio-group-2'" (onChange)="check2('Yes')">
            <span>Yes</span>
          </ap-radio>
                  <ap-radio [styleClass]="'a-mx-10'" [value]="'No'" [(ngModel)]="isPFICInDB" [ngModelOptions]="{standalone: true}" [name]="'radio-group-2'" (onChange)="check2('No')">
            <span>No</span>
          </ap-radio>
                </ap-radio-group>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <dst-template-leid-selector class="required-field" [label]="'Please specify the LEID of the PFIC'"
                                      [labelId]="'4'" (onSelectedLEChanged)="onPFICChanged($event)">
          </dst-template-leid-selector>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="entity-details">
            <span class="ed-label">Name of PFIC:</span>
            <span class="template-color-blue">{{!PFIC ? '' : PFIC.ENTITY}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="entity-details">
            <span class="ed-label">Identifying Number:</span>
            <span class="template-color-blue">{{!PFIC ? '' : (PFIC.EIN ? PFIC.EIN : 'N/A')}}</span>
          </div>
        </div>
      </div>
      @if (PFIC && PFIC.EIN === undefined) {
<div class="entity-details">
        <span class="ed-label">EIN Missing Reason:</span>
        <div class="d-inline-block">
          <ap-dropdown class="ap-form-field-my-wrapper" [list]="missingReasonsEIN[0]?.data || []" [selectType]="'single'" [title]="'EIN Missing Reason'" [inputAriaLabel]="'EIN Missing Reason'"
                       [optionName]="'text'"
                       [(ngModel)]="selectedPFICEINReasonItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                       (onSelect)="onPFICEINMissingReasonChanged($event)" [required]="true">
            @for (item of missingReasonsEIN[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
              [optionName]="'text'"
              [ariaLabel]="setAriaLabel(item, 'EIN Missing Reason')"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
          </ap-dropdown>
        </div>
      </div>
}
      <!-- PFIC Address Details -->
      <div class="mt-3 pl-3" [style.display]="PFIC ? 'block' : 'none'">
        <div class="row">
          <div class="col-md-12">
            <div class="entity-details">
              <span class="ed-label sub-ed-label">Country:</span>
              <div class="d-inline-block">
                <ap-dropdown class="ap-form-field-my-wrapper field-full-width" [list]="countries[0]?.data || []" [selectType]="'single'"
                             [showSearchbox]="true" [title]="'Country'" [inputAriaLabel]="'Country'" [optionName]="'text'"
                             [(ngModel)]="selectedPFICCountryItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                             (onSelect)="onPFICCountryChanged($event)">
                  @for (item of countries[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                    [optionName]="'text'"
                    [ariaLabel]="setAriaLabel(item, 'Country')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                </ap-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="entity-details">
              <span class="ed-label sub-ed-label">Address Line 1:</span>
              <div class="d-inline-block">
                <ap-field [styleClass]="'ap-form-field-my-wrapper'" [title]="''" [fieldId]="'5'" [hideTitleOnInput]="true">
                    <input appkit-field [ngModel]="PFICAdd1" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPFICAddrChanged({value: $event}, 1)"  aria-label="5" />
                </ap-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="entity-details">
              <span class="ed-label sub-ed-label">Address Line 2:</span>
              <div class="d-inline-block">
                <ap-field [styleClass]="'ap-form-field-my-wrapper'" [title]="''" [fieldId]="'6'" [hideTitleOnInput]="true">
                    <input appkit-field [ngModel]="PFICAdd2" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPFICAddrChanged({value: $event}, 2)"  aria-label="6" />
                </ap-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="entity-details">
              <span class="ed-label sub-ed-label">{{ PFICUS ? 'City:' : 'City / Town:'}}</span>
              <div class="d-inline-block">
                <ap-field [styleClass]="'ap-form-field-my-wrapper'" [title]="''" [fieldId]="'7'" [hideTitleOnInput]="true">
                    <input appkit-field [ngModel]="PFICCity" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPFICCityChanged({value: $event})"  aria-label="7" />
                </ap-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            @if (PFICUS) {
<div class="entity-details">
              <span class="ed-label sub-ed-label">State:</span>
              <div class="d-inline-block">
                <ap-dropdown class="ap-form-field-my-wrapper field-full-width" [list]="states[0]?.data || []" [selectType]="'single'"
                             [showSearchbox]="true" [title]="'State'" [inputAriaLabel]="'State'" [optionName]="'text'"
                             [(ngModel)]="selectedPFICStateItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                             (onSelect)="onPFICStateChanged($event)">
                  @for (item of states[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                    [optionName]="'text'"
                    [ariaLabel]="setAriaLabel(item, 'State')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                </ap-dropdown>
              </div>
            </div>
}
            @if (!PFICUS) {
<div class="entity-details">
              <span class="ed-label sub-ed-label">Province or State:</span>
              <div class="d-inline-block">
                <ap-field [styleClass]="'ap-form-field-my-wrapper'" [title]="''" [fieldId]="'8'" [hideTitleOnInput]="true">
                    <input appkit-field [ngModel]="PFICStateProv" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPFICStateProvChanged({value: $event})"  aria-label="8" />
                </ap-field>
              </div>
            </div>
}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="entity-details">
              <span class="ed-label sub-ed-label">{{ PFICUS ? 'Zip:' : 'Postal Code:'}}</span>
              <div class="d-inline-block">
                <ap-field [styleClass]="'ap-form-field-my-wrapper'" [title]="''" [fieldId]="'9'" [hideTitleOnInput]="true">
                    <input appkit-field [ngModel]="PFICZip" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPFICZipChanged({value: $event})"  aria-label="9" />
                </ap-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PFIC Tax Years -->
      <div class="row mt-4">
        <div class="col-md-12">PFIC/QEF Tax Year</div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ap-radio-group [ariaLabel]="'PFIC/QEF Tax Year'">
                  <ap-radio [styleClass]="'a-mx-10'" [value]="'Year'" [(ngModel)]="PFICTaxYearType" [ngModelOptions]="{standalone: true}" [name]="'radio-group-3'" (onChange)="check3($event, 'Year')">
            <span>Specify By Calendar Year</span>
          </ap-radio>
                  <ap-radio [styleClass]="'a-mx-10'" [value]="'Range'" [(ngModel)]="PFICTaxYearType" [ngModelOptions]="{standalone: true}" [name]="'radio-group-3'" (onChange)="check3($event, 'Range')">
            <span>Specify By Date Range</span>
          </ap-radio>
                </ap-radio-group>
        </div>
      </div>
      @if (PFICTaxYearType === 'Year') {
<div class="row">
        <div class="col-md-12">
          <div class="entity-details">
            <span class="mt-2 ml-3" style="width: 265px;">Calendar Year</span>
            <div class="d-inline-block">
              <ap-dropdown class="ap-form-field-my-wrapper field-full-width select-dropdown" [list]="taxYearsPFIC[0]?.data || []" [selectType]="'single'" [showSearchbox]="true" [title]="'Tax Year'" [inputAriaLabel]="'Tax Year'"
                           [optionName]="'text'"
                           [(ngModel)]="selectedPFICTaxYearItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                           (onSelect)="onPFICTYChanged($event)">
                @for (item of taxYearsPFIC[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                  [optionName]="'text'"
                  [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
              </ap-dropdown>
            </div>
          </div>
        </div>
      </div>
}
      @if (PFICTaxYearType === 'Range') {
<div class="row ap-form-field-my-wrapper mt-1">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="entity-details">
                <span style="width: 260px;">Tax Year Beginning</span>
                <div class="d-inline-block">
                <app-date-picker-with-clear
                  class="date-field date-field-margin"
                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="''"
                  [required]="false"
                  (dateChange)="dateChange($event, 4)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(4)"
                  [(ngModel)]="companyOrFundBeginningTY"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <div class="entity-details">
                <span style="width: 260px;">Tax Year Ending</span>
                <div class="d-inline-block">
                <app-date-picker-with-clear
                  class="date-field date-field-margin"
                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="''"
                  [required]="false"
                  (dateChange)="dateChange($event, 5)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(5)"
                  [(ngModel)]="companyOrFundEndingTY"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
}

    </div>

    <br/>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part I&nbsp;&nbsp;</strong>
          <strong>Summary of Annual Information</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="" formGroupName="partOne">
      <div class="section-content ap-form-field-my-wrapper">
        <ol class="section-content list-content m-0 pb-0" start="1">

          <li>
            <div class="row inline-label-row">
              <div class="inline-label">
                <label [for]="'sharesDesc'">Description of each class of shares held by the shareholder: </label>
              </div>
              <div class="inline-input">
                <ap-field [styleClass]="'text-box d-flex'" [fieldId]="'sharesDesc'" [title]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="shareHoldersSharesDesc" [ngModelOptions]="{standalone: true}"  aria-label="Shares desc" />
                </ap-field>
              </div>
            </div>
            <ap-checkbox [styleClass]="'a-mx-10'"
                         [(ngModel)]="sharesOwnedWithSpouse" [ngModelOptions]="{standalone: true}">
              <span>Check if shares jointly owned with spouse.</span>
            </ap-checkbox>
          </li>

          <li class="pt-2">
            <div class="row inline-label-row">
              <div class="inline-label">
                Date shares acquired during the taxable year, if applicable:
              </div>
              <div class="inline-input">
                <app-date-picker-with-clear
                  class="date-field"
                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="''"
                  [required]="false"
                  (dateChange)="dateChange($event, 1)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(1)"
                  [(ngModel)]="dateSharesAcq"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
              </div>
            </div>
          </li>

          <li class="pt-2">
            <div class="row">
              <div class="col-md-4">
                <label [for]="'noOfSharesYrEnd'">Number of shares held at the end of the taxable year: </label>
              </div>
              <div class="col-md-3">
                <ap-field [fieldId]="'noOfSharesYrEnd'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field no-label number-field-input amount-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="noOfSharesYearEnd" [ngModelOptions]="{standalone: true}"  aria-label="No of shares yr end" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="pt-2">
            <div class="row">
              <div class="col-md-12">
                Value of shares held at the end of the taxable year (check the appropriate box, if applicable):
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-md-3 checkbox-cell">
                <b>(a)</b>
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="shareValueTaxyearEnd === 0" [ngModelOptions]="{standalone: true}"
                             (onChange)="onShareValueRangeChanged($event, 0)">
                  <span>$0-50,000</span>
                </ap-checkbox>
              </div>
              <div class="col-md-3 checkbox-cell">
                <b>(b)</b>
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="shareValueTaxyearEnd === 50001" [ngModelOptions]="{standalone: true}"
                             (onChange)="onShareValueRangeChanged($event, 50001)">
                  <span>$50,001 - 100,000</span>
                </ap-checkbox>
              </div>
              <div class="col-md-3 checkbox-cell">
                <b>(c)</b>
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="shareValueTaxyearEnd === 100001" [ngModelOptions]="{standalone: true}"
                             (onChange)="onShareValueRangeChanged($event, 100001)">
                  <span>$100,001 - 150,000</span>
                </ap-checkbox>
              </div>
              <div class="col-md-3 checkbox-cell">
                <b>(d)</b>
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="shareValueTaxyearEnd === 150001" [ngModelOptions]="{standalone: true}"
                             (onChange)="onShareValueRangeChanged($event, 150001)">
                  <span>$150,001 - 200,000</span>
                </ap-checkbox>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-md-12 d-flex align-items-center part-two">
                <b class="pr-2">(e)</b> if more than $200,000, list value:
                <ap-field [fieldId]="'valueOfSharesYearEnd'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field required-field amount-input number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="valueOfSharesYearEnd" [ngModelOptions]="{standalone: true}"  aria-label="Value of shares year end" />
                </ap-field>
              </div>
            </div>

          </li>

          <li class="pt-2">
            <div class="row">
              <div class="col-md-12">
                Type of PFIC and amount of any excess distribution or gain treated as an excess distribution under section 1291, inclusion under section 1293,
                or inclusion or deduction under section 1296:
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 p-2 checkbox-cell">
                (a)
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="pficType === 1" [ngModelOptions]="{standalone: true}"
                             (onChange)="onPficTypeChanged($event, 1)">
                  <span>Section 1291</span>
                </ap-checkbox>
              </div>
              <div class="col-md-4 p-2 d-flex align-items-center part-two part-two--fixed-number-field">
                <span class="currency-prefix">$</span>
                <ap-field [fieldId]="'pficType1Amount'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="pficType1Amount" [ngModelOptions]="{standalone: true}"  aria-label="Pfic type1 amount" />
                </ap-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 p-2 checkbox-cell">
                (b)
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="pficType === 2" [ngModelOptions]="{standalone: true}"
                             (onChange)="onPficTypeChanged($event, 2)">
                  <span>Section 1293 (Qualified Election Fund)</span>
                </ap-checkbox>
              </div>
              <div class="col-md-4 p-2 d-flex align-items-center part-two part-two--fixed-number-field">
                <span class="currency-prefix">$</span>
                <ap-field [fieldId]="'pficType2Amount'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="pficType2Amount" [ngModelOptions]="{standalone: true}"  aria-label="Pfic type2 amount" />
                </ap-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 p-2 checkbox-cell">
                (c)
                <ap-checkbox [styleClass]="'a-mx-10 required-field-checkbox'" [ngModel]="pficType === 3" [ngModelOptions]="{standalone: true}"
                             (onChange)="onPficTypeChanged($event, 3)">
                  <span>Section 1296 (Mark to Market)</span>
                </ap-checkbox>
              </div>
              <div class="col-md-4 p-2 d-flex align-items-center part-two part-two--fixed-number-field">
                <span class="currency-prefix">$</span>
                <ap-field [fieldId]="'pficType3Amount'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="pficType3Amount" [ngModelOptions]="{standalone: true}"  aria-label="Pfic type3 amount" />
                </ap-field>
              </div>
            </div>
          </li>

        </ol>
      </div>
    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part II&nbsp;&nbsp;</strong>
          <strong>Elections</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="" formGroupName="partTwo">
      <p class="m-0 pt-3 pb-1">Check the applicable box for this type of election</p>
      <div class="section-content list-content list-spacing pt-0">
        <ol class="list-upper-alpha m-0">
          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'electionToTreat'"
                           [(ngModel)]="electionToTreat" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Election To Treat the PFIC as a QEF: I, a shareholder of a PFIC, elect to treat the PFIC as a QEF. Complete lines 6a through 7c of Part
                III.</p>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'electionToExtend'"
                           [(ngModel)]="electionToExtend" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <div class="election-text">
                <p class="mb-0">Election To Extend Time For Payment of Tax: I, a shareholder of a QEF, elect to extend the time for payment of tax on the
                  undistributed earnings and profits of the QEF until this election is terminated. Complete lines 8a through 9c of Part III to calculate the tax
                  that may be deferred. Note: If any portion of line 6a or line 7a of Part III is includible under section 951, you may not make this election.
                  Also, see sections 1294(c) and 1294(f) and the related regulations for events that terminate this election.</p>
                <ap-field [styleClass]="'text-box'" [fieldId]="'electionToExtendDesc'" [title]="''" [hideTitleOnInput]="true">
                      <input appkit-field [(ngModel)]="electionToExtendDesc" [ngModelOptions]="{standalone: true}"  aria-label="Election to extend desc" />
                </ap-field>
              </div>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'electionToMarkToMarket'"
                           [(ngModel)]="electionToMarkToMarket" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Election To Mark-to-Market PFIC Stock: I, a shareholder of a PFIC, elect to mark-to-market the PFIC stock that is marketable within the meaning
                of section 1296(e). Complete Part IV.</p>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'deemedSalesElection'"
                           [(ngModel)]="deemedSalesElection" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Deemed Sale Election: I, a shareholder on the first day of a PFIC's first tax year as a QEF, elect to recognize gain on the deemed sale of my
                interest in the PFIC. Enter gain or loss on line 15f of Part V.</p>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'deemedDividentElection'"
                           [(ngModel)]="deemedDividentElection" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Deemed Dividend Election: I, a shareholder on the first day of a PFIC's first tax year as a QEF that is a controlled foreign corporation (CFC),
                elect to treat an amount equal to my share of the post-1986 earnings and profits of the CFC as an excess distribution. Enter this amount on line
                15e of Part V. If the excess distribution is greater than zero, also complete line 16 of Part V</p>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'electionToRecognizeGain'"
                           [(ngModel)]="electionToRecognizeGain" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Election To Recognize Gain on Deemed Sale of PFIC: I, a shareholder of a former PFIC or a PFIC to which section 1297(d) applies, elect to treat
                as an excess distribution the gain recognized on the deemed sale of my interest in the PFIC, or, if I qualify, my share of the PFIC's post-1986
                earnings and profits deemed distributed, on the last day of its last tax year as a PFIC under section 1297(a). Enter gain on line 15f of Part
                V.</p>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'deemedDividendElectionWrtSection1297'"
                           [(ngModel)]="deemedDividendElectionWrtSection1297" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Deemed Dividend Election With Respect to a Section 1297(e) PFIC. I, a shareholder of a section 1297(e) PFIC, within the meaning of Regulations
                section 1.1297-3(a), elect to make a deemed dividend election with respect to the Section 1297(e) PFIC. My holding period in the stock of the
                Section 1297(e) PFIC includes the CFC qualification date, as defined in Regulations section 1.1297-3(d). Enter the excess distribution on line
                15e, Part V. If greater than zero, also complete line 16, Part V.</p>
            </div>
          </li>

          <li>
            <div class="d-flex">
              <ap-checkbox [styleClass]="'a-mx-10'" [inputId]="'deemedDividendElectionWrtFormerPfic'"
                           [(ngModel)]="deemedDividendElectionWrtFormerPfic" [ngModelOptions]="{standalone: true}">
              </ap-checkbox>
              <p>Deemed Dividend Election With Respect to a Former PFIC. I, a shareholder of a former PFIC, within the meaning of Regulations section
                1.1298-3(a), elect to make a deemed dividend election with respect to the former PFIC. My holding period in the stock of the former PFIC
                includes the termination date, as defined in Regulations section 1.1298-3(d). Enter the excess distribution on line 15e, Part V. If excessive
                distribution is greater than zero, also complete line 16, Part V.</p>
            </div>
          </li>

        </ol>
      </div>
    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part III&nbsp;&nbsp;</strong>
          <strong>Income From a Qualified Electing Fund (QEF)</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="" formGroupName="partThree">
      <p class="m-0 pt-3">All QEF shareholders complete lines 6a through 7c. If you are making Election B, also complete lines 8a through 9c. (See
        instructions.)</p>
      <div class="section-content pt-2 ap-form-field-my-wrapper">
        <ol class="list-content list-spacing m-0" start="6">

          <li class="li-apdix-a" style="counter-reset: count 5;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter your pro rata share of the ordinary earnings of the QEF.</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': (electionToTreat || electionToExtend)}">
                <ap-field [fieldId]="'proRateShares'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="proRateShares" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine6', 0, 'proRateShares')"  aria-label="Pro rate shares" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 5;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter the portion of line 6a that is included in income under section 951 or that may be excluded under section 1293(g)</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': (electionToTreat || electionToExtend)}">
                <ap-field [fieldId]="'portionLine6a'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="portionLine6a" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine6', 0, 'portionLine6a')"  aria-label="Portion line6a" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 5;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Subtract line 6b from line 6a. Enter this amount on your tax return as ordinary income</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ OrdinaryIncome }}</span>
              </div>
            </div>
          </li>

          <li class="li-apdix-a" style="counter-reset: count 6;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter your pro rata share of the total net capital gain of the QEF</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': (electionToTreat || electionToExtend)}">
                <ap-field [fieldId]="'proRateSharesNetGain'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="proRateSharesNetGain" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine7', 0, 'proRateSharesNetGain')"  aria-label="Pro rate shares net gain" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 6;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter the portion of line 7a that is included in income under section 951 or that may be excluded under section 1293(g)</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': (electionToTreat || electionToExtend)}">
                <ap-field [fieldId]="'portionLine7a'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="portionLine7a" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine7', 0, 'portionLine7a')"  aria-label="Portion line7a" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 6;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Subtract line 7b from line 7a. This amount is a net long-term capital gain. Enter this amount in Part III of the Schedule D used for your
                  income tax return.(See instructions.)</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ NetCapitalGain }}</span>
              </div>
            </div>
          </li>

          <li class="li-apdix-a" style="counter-reset: count 7;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Add lines 6c and 7c</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ Line6cAnd7cSum }}</span>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 7;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter the total amount of cash and the fair market value of other property distributed or deemed distributed to you during the tax year of
                  the QEF. (See instructions)</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToExtend}">
                <ap-field [fieldId]="'cashPropertyDeemedDistributedCash'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="cashPropertyDeemedDistributedCash" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine8', 0, 'cashPropertyDeemedDistributedCash')"  aria-label="Cash property deemed distributed cash" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 7;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter the portion of line 8a not already included in line 8c that is attributable to shares in the QEF that you disposed of, pledged, or otherwise
                  transferred during the tax year</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToExtend}">
                <ap-field [fieldId]="'portionLine8c'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="portionLine8c" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine8', 0, 'portionLine8c')"  aria-label="Portion line8c" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-d" style="counter-reset: count 7;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Add lines 8b and 8c</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ Line8bAnd8cSum }}</span>
              </div>
            </div>
          </li>

          <li class="li-apdix-e" style="counter-reset: count 7;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Subtract line 8d from line 8a, and enter the difference (if zero or less, enter amount in brackets)
                  Important: If line 8e is greater than zero, and no portion of line 6a or 7a is includible in income under section 951, you may make Election B
                  with respect to the amount on line 8e</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ Line8dAnd8aSubt }}</span>
              </div>
            </div>
          </li>

          <li class="li-apdix-a" style="counter-reset: count 8;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter the total tax for the tax year. (See instructions.)</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToExtend}">
                <ap-field [fieldId]="'totalTax'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="totalTax" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine9', 0, 'totalTax')"  aria-label="Total tax" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 8;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Enter the total tax for the tax year determined without regard to the amount entered on line 8e.</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToExtend}">
                <ap-field [fieldId]="'totalTaxWithoutRegard'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="totalTaxWithoutRegard" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partThreeLine9', 0, 'totalTaxWithoutRegard')"  aria-label="Total tax without regard" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 8;">
            <div class="row pl-3">
              <div class="col-md-8">
                <p>Subtract line 9b from line 9a. This is the deferred tax, the time for payment of which is extended by making Election B. (See
                  instructions.)</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ Line9bAnd9aSubt }}</span>
              </div>
            </div>
          </li>

        </ol>
      </div>
    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part IV&nbsp;&nbsp;</strong>
          <strong>Gain or (Loss) From Mark-to-Market Election (See instructions.)</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="" formGroupName="partFour">
      <div class="section-content ap-form-field-my-wrapper">
        <ol class="list-content list-spacing m-0" start="10">

          <li class="li-apdix-a" style="counter-reset: count 9;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter the fair market value of your PFIC stock at the end of the tax year.</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToMarkToMarket}">
                <ap-field [fieldId]="'fairMarketValue'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="fairMarketValue" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partFourLine10', 0, 'fairMarketValue')"  aria-label="Fair market value" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 9;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter your adjusted basis in the stock at the end of the tax year</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                <ap-field [fieldId]="'adjustedBasisStock'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="adjustedBasisStock" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partFourLine10', 0, 'adjustedBasisStock')"  aria-label="Adjusted basis stock" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 9;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Subtract line 10b from line 10a. If a gain, do not complete lines 11 and 12. Include this amount as ordinary income on your tax return. If a
                  loss, go to line 11.</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ OrdinaryIncomeOnTaxReturn }}</span>
              </div>
            </div>
          </li>

          <li>
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter any unreversed inclusions (as defined in section 1296(d))</p>
              </div>
              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToMarkToMarket}">
                <ap-field [fieldId]="'unreversedInclusion'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="unreversedInclusion" [ngModelOptions]="{standalone: true}"  aria-label="Unreversed inclusion" />
                </ap-field>
              </div>
            </div>
          </li>

          <li>
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter the loss from line 10c, but only to the extent of unreversed inclusions on line 11. Include this amount as an ordinary loss on your tax
                  return</p>
              </div>
              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                <ap-field [fieldId]="'lossLine10c'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="lossLine10c" [ngModelOptions]="{standalone: true}"  aria-label="Loss line10c" />
                </ap-field>
              </div>
            </div>
          </li>

          <li>
            <b class="pl-4">If you sold or otherwise disposed of any section 1296 stock (see instructions) during the tax year:</b>
          </li>

          <li class="li-apdix-a mt-2" style="counter-reset: count 12;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p> Enter the fair market value of the stock on the date of sale or disposition</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': electionToMarkToMarket}">
                <ap-field [fieldId]="'fairMarketDispositionValue'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="fairMarketDispositionValue" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partFourLine13', 0, 'fairMarketDispositionValue')"  aria-label="Fair market disposition value" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 12;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter the adjusted basis of the stock on the date of sale or disposition</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                <ap-field [fieldId]="'adjustedBasisDispositionStock'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="adjustedBasisDispositionStock" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateValue({value: $event}, 'partFourLine13', 0, 'adjustedBasisDispositionStock')"  aria-label="Adjusted basis disposition stock" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 12;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Subtract line 13b from line 13a. If a gain, do not complete line 14. Include this amount as ordinary income on your tax return. If a loss, go
                  to line 14</p>
              </div>

              <div class="col-md-4 p-0 text-align-end">
                <span>{{ Line13bAnd13aSubt }}</span>
              </div>
            </div>
          </li>

          <li class="li-apdix-a" style="counter-reset: count 13;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p> Enter any unreversed inclusions (as defined in section 1296(d))</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                <ap-field [fieldId]="'unreversedInclusionSection1296'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="unreversedInclusionSection1296" [ngModelOptions]="{standalone: true}"  aria-label="Unreversed inclusion section1296" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-b" style="counter-reset: count 13;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter the loss from line 13c, but only to the extent of unreversed inclusions on line 14a. Include this amount as an ordinary loss on your
                  tax return. If the loss on line 8c exceeds unreversed inclusions on line 14a, complete line 14c</p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                <ap-field [fieldId]="'lossLine13c'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="lossLine13c" [ngModelOptions]="{standalone: true}"  aria-label="Loss line13c" />
                </ap-field>
              </div>
            </div>
          </li>

          <li class="li-apdix-c" style="counter-reset: count 13;">
            <div class="row pl-4">
              <div class="col-md-8">
                <p>Enter the amount by which the loss on line 13c exceeds unreversed inclusions on line 14a. Include this amount on your tax return according to
                  the rules generally applicable for losses provided elsewhere in the Code and regulations
                  Note: See instructions in case of multiple dispositions.
                </p>
              </div>

              <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                <ap-field [fieldId]="'lossLine13cExceedInclusion'" [title]="''" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field amount-input amount-input-container number-field-input'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="lossLine13cExceedInclusion" [ngModelOptions]="{standalone: true}"  aria-label="Loss line13c exceed inclusion" />
                </ap-field>
              </div>
            </div>
          </li>

        </ol>
      </div>
    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part V&nbsp;&nbsp;</strong>
          <strong>Distributions From and Dispositions of Stock of a Section 1291 Fund</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="tab-section section-content" formGroupName="partFive">
      <p class="pt-3">Complete a separate Part IV for each excess distribution</p>
      <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'" [compact]="true"
                 (onClick)="addTab('partFive')">
        <span class="Appkit4-icon icon-plus-outline"></span> Add
      </ap-button>

      <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'"
                 [compact]="true"
                 [disabled]="part5Tabs.length > 1 && part5Selected.value === 0"
                 (onClick)="removeTab(part5Selected.value, 'partFive')">
        <span class="Appkit4-icon icon-minus-outline"></span> Remove
      </ap-button>

      <mat-tab-group [selectedIndex]="part5Selected.value" (selectedIndexChange)="selectTab($event, 'partFive')" animationDuration="0ms">
        @for (tab of part5Tabs; track $index; let index = $index) {
<mat-tab [label]="tab.tab">
          <div class="tab-section-content section-content ap-form-field-my-wrapper pl-4">

            <ol class="list-content m-0" start="15">

              <li class="mb-3" style="list-style: none; counter-increment: none;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Enter the three-letter currency code (see instructions) </p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <input
                      class="form8621-plain-field-input number-field span-match-rgroup"
                      type="text"
                      [id]="'partFiveCurrencyCode'"
                      maxlength="3"
                      [(ngModel)]="part5Tabs[index].partFiveCurrencyCode"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue({value: $event}, 'partFiveLine15', index, 'partFiveCurrencyCode')"
                      aria-label="Part five currency code" />
                  </div>
                </div>
              </li>

              <li class="li-apdix-a" style="counter-reset: count 14;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Enter your total distributions from the section 1291 fund during the current tax year with respect to the applicable stock. If the
                      holding period of the stock began in the current tax year, see instructions</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'totalDistribution'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].totalDistribution" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine15', index, 'totalDistribution')"  aria-label="Total distribution" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-b" style="counter-reset: count 14;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Enter the total distributions (reduced by the portions of such distributions that were excess distributions but not included in income
                      under section 1291(a)(1)(B)) made by the fund with respect to the applicable stock for each of the 3 years preceding the current tax year
                      (or if shorter, the portion of the shareholder's holding period before the current tax year)</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'totalDistributionByFund'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].totalDistributionByFund" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine15', index, 'totalDistributionByFund')"  aria-label="Total distribution by fund" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-c" style="counter-reset: count 14;">
                <div class="row mb-2 pl-2">
                  <p class="col-md-12 mb-2">Divide line 15b by 3. Enter number of preceding tax years if less than 3 years (See instructions)</p>
                  <div class="col-md-3 d-flex">
                    <ap-field [fieldId]="'precedingTaxYear'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field no-label amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].precedingTaxYear" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine15', index, 'precedingTaxYear')"  aria-label="Preceding tax year" />
                    </ap-field>
                  </div>
                  <div class="col-md-3"></div>
                  <div class="col-md-3"></div>
                  <div class="col-md-3 p-0 text-align-end">
                    <span>{{ part5Tabs[index].Divide15bBy3 }}</span>
                  </div>
                </div>
              </li>

              <li class="li-apdix-d" style="counter-reset: count 14;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Multiply line 15c by 125% (1.25)</p>
                  </div>

                  <div class="col-md-4 p-0 text-align-end">
                    <span>{{ part5Tabs[index].Multiply15cBy125percent }}</span>
                  </div>
                </div>
              </li>

              <li class="li-apdix-e" style="counter-reset: count 14;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>(1) Subtract line 15d from line 15a. This amount, if more than zero, is the excess distribution with respect to the applicable stock. If zero
                      or less and you did not dispose of stock during the tax year, do not complete the rest of Part V. See instructions if you received more
                      than one distribution during the current tax year. Also, see instructions for rules for reporting a nonexcess distribution on your income
                      tax return</p>
                  </div>

                  <div class="col-md-4 p-0 text-align-end">
                    <span>{{ part5Tabs[index].Subt15dFrom15a }}</span>
                  </div>
                </div>
              </li>

              <li class="li-apdix-e" style="counter-reset: count 14;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>(2) If the amount on line 15e(1) is in a foreign currency, convert to U.S. dollars and enter here. If line 15e(1) is in
                      U.S. dollars, enter that amount here (see instructions)</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'distriAndDisposOfStockTypTotalExcessDistributionUS'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].distriAndDisposOfStockTypTotalExcessDistributionUS" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine15', index, 'distriAndDisposOfStockTypTotalExcessDistributionUS')"  aria-label="Distri and dispos of stock typ total excess distribution us" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-f" style="counter-reset: count 14;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Enter gain or loss from the disposition of stock of a section 1291 fund or former section 1291 fund. If a gain, complete line 16. If a
                      loss, show it in brackets and do not complete line 16</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field" [ngClass]="{'required-field': (deemedSalesElection || electionToRecognizeGain)}">
                    <ap-field [fieldId]="'gainOrLossDistributionSection1291'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].gainOrLossDistributionSection1291" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine15', index, 'gainOrLossDistributionSection1291')"  aria-label="Gain or loss distribution section1291" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-a" style="counter-reset: count 15;">
                <div class="row pl-2">
                  <div class="col-md-12">
                    <p class="m-0">Attach a statement for each distribution and disposition. Show your holding period for each share of stock or block of shares held.
                      Allocate the excess distribution to each day in you holding period. Add all amounts that are allocated to days in each tax year</p>
                  </div>

                  <div class="col-md-12 pr-0">
                    <div class="a-textarea-box a-field-length-validation form-inlines dci-textarea-wrapper">
                      <ap-field [title]="''" [fieldId]="'stmtForDistAndDisp'" [hideTitleOnInput]="true">
                    <textarea appkit-field maxlength="100" [(ngModel)]="part5Tabs[index].stmtForDistAndDisp" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue({value: $event}, 'partFiveLine16', index, 'stmtForDistAndDisp')" aria-label="Stmt for dist and disp"></textarea>
                        <ap-field-counter [max]="100" [value]="part5Tabs[index].stmtForDistAndDisp"></ap-field-counter>
                      </ap-field>
                    </div>
                  </div>
                </div>
              </li>

              <li class="li-apdix-b mt-3" style="counter-reset: count 15;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Enter the total of the amounts determined in line 16a that are allocable to the current tax year and tax years before the foreign
                      corporation became a PFIC (pre-PFIC tax years). Enter these amounts on your income tax return as other income.</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'totalAmountLine16a'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].totalAmountLine16a" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine16', index, 'totalAmountLine16a')"  aria-label="Total amount line16a" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-c" style="counter-reset: count 15;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Enter the aggregate increases in tax (before credits) for each tax year in your holding period (other than the current tax year and
                      pre-PFIC years). (See instructions.)</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'aggIncreaseInTax'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].aggIncreaseInTax" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine16', index, 'aggIncreaseInTax')"  aria-label="Agg increase in tax" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-d" style="counter-reset: count 15;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Foreign tax credit. (See instructions.)</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'ftc'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].ftc" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine16', index, 'ftc')"  aria-label="Ftc" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="li-apdix-e" style="counter-reset: count 15;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Subtract line 16d from line 16c. Enter this amount on your income tax return as "additional tax". (See instructions.)</p>
                  </div>

                  <div class="col-md-4 p-0 text-align-end">
                    <span>{{ part5Tabs[index].Subt16dFrom16c }}</span>
                  </div>
                </div>
              </li>

              <li class="li-apdix-f" style="counter-reset: count 15;">
                <div class="row pl-2">
                  <div class="col-md-8">
                    <p>Determine interest on each net increase in tax determined on line 16e using the rates and methods of section 6621. Enter the aggregate
                      amount of interest here. (See instructions.)</p>
                  </div>

                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'interestTaxNetIncrease'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="part5Tabs[index].interestTaxNetIncrease" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine16', index, 'interestTaxNetIncrease')"  aria-label="Interest tax net increase" />
                    </ap-field>
                  </div>
                </div>
              </li>

            </ol>

          </div>
        </mat-tab>
}
      </mat-tab-group>

    </div>

    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part VI&nbsp;&nbsp;</strong>
          <strong>Status of Prior Year Section 1294 Elections and Termination of Section 1294 Elections</strong>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="tab-section section-content" formGroupName="partSix">
      <p class="pt-3">Complete a separate column for each outstanding election. Complete lines 17 through 20 to report the status of outstanding prior year
        section 1294 elections. Complete lines 21 through 24 only if a section 1294 election is terminated in the current year. Complete lines 25 and 26 only if
        there is a partial termination of a section 1294 election in the current tax year.</p>
      <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'" [compact]="true"
                 (onClick)="addTab('partSix')">
        <span class="Appkit4-icon icon-plus-outline"></span> Add
      </ap-button>

      <ap-button class="btn-plus-minus btn-plus-minus--unified" [btnType]="'secondary'"
                 [compact]="true"
                 [disabled]="part6Tabs.length > 1 && part6Selected.value === 0"
                 (onClick)="removeTab(part6Selected.value, 'partSix')">
        <span class="Appkit4-icon icon-minus-outline"></span> Remove
      </ap-button>

      <mat-tab-group [selectedIndex]="part6Selected.value" (selectedIndexChange)="selectTab($event, 'partSix')" animationDuration="0ms">
        @for (tab of part6Tabs; track $index; let index = $index) {
<mat-tab [label]="tab.tab">
          <div class="tab-section-content section-content ap-form-field-my-wrapper pl-4">

            <ol class="section-content list-content m-0 pb-0" start="17">
              <li class="mb-3" style="counter-reset: count 16;">
                <div class="row">
                  <div class="col-md-8">
                    <p>Tax Year of outstanding election</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-dropdown class="ap-form-field-my-wrapper field-full-width select-dropdown select-dropdown-container form8621-fixed-dropdown mt-0"
                                 [id]="'electionYear'" [list]="taxYearsOE[0]?.data || []" [selectType]="'single'" [showSearchbox]="true" [title]="'Tax Year'" [inputAriaLabel]="'Tax Year'"
                                 [optionName]="'text'"
                                 [(ngModel)]="selectedOETaxYearItem" [ngModelOptions]="{standalone: true}" [hideTitleOnInput]="true"
                                 (onSelect)="onOutstandingElectionTYChanged($event, index)">
                      @for (item of taxYearsOE[0]?.data || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                        [optionName]="'text'"
                        [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                        (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                    </ap-dropdown>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Undistributed earnings to which the election relates</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'unDistEarnings'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="unDistEarnings" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine18', index, 'unDistEarnings')"  aria-label="Un dist earnings" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Deferred Tax</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'deferredTax'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="deferredTax" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine19', index, 'deferredTax')"  aria-label="Deferred tax" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Interest accrued on deferred tax (line 19) as of the filing date</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'deferredTaxInterest'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="deferredTaxInterest" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine20', index, 'deferredTaxInterest')"  aria-label="Deferred tax interest" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Event terminating election</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field class="form8621-fixed-text-field" [styleClass]="'text-box amount-input-container'" [fieldId]="'evtTermElection'" [title]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="evtTermElection" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine21',  index, 'evtTermElection')"  aria-label="Evt term election" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li class="mt-3">
                <div class="row">
                  <div class="col-md-8">
                    <p>Earnings distributed or deemed distributed during the tax year</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'earnDistOrDeemed'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="earnDistOrDeemed" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine22', index, 'earnDistOrDeemed')"  aria-label="Earn dist or deemed" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Deferred tax due with this return</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'deferredTaxDue'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="deferredTaxDue" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine23', index, 'deferredTaxDue')"  aria-label="Deferred tax due" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Accrued interest due with this return</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'accrdInterestDue'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="accrdInterestDue" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine24', index, 'accrdInterestDue')"  aria-label="Accrd interest due" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Deferred tax outstanding after partial termination of election</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'deferredTaxAftTerm'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="deferredTaxAftTerm" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine25', index, 'deferredTaxAftTerm')"  aria-label="Deferred tax aft term" />
                    </ap-field>
                  </div>
                </div>
              </li>

              <li>
                <div class="row">
                  <div class="col-md-8">
                    <p>Interest accrued after partial termination of election</p>
                  </div>
                  <div class="col-md-4 p-0 d-flex part-two part-two--fixed-number-field">
                    <ap-field [fieldId]="'accrdInterestAftTerm'" [title]="''" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true"
                      [styleClass]="'number-field amount-input amount-input-container number-field-input'">
                    <input appkit-field [(ngModel)]="accrdInterestAftTerm" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateValue({value: $event}, 'partFiveLine26', index, 'accrdInterestAftTerm')"  aria-label="Accrd interest aft term" />
                    </ap-field>
                  </div>
                </div>
              </li>

            </ol>
          </div>
        </mat-tab>
}
      </mat-tab-group>

    </div>

    <div class="leid-list d-flex mt-2">
      <span>LEIDs: </span>
      <div>
        @if (shareholder) {
<span class="template-color-blue">{{ shareholder.LEID }}</span>
}
      </div>
    </div>

  </div>
</div>

@if (showPficLegalEntityDBModal) {
<ap-modal #pficLegalEntityDatabase
         
          [appModalId]="'pfic-entity-db'"
          [ariaLabel]="'Is PFIC in Legal Entity Database?'"
          [title]="'Is PFIC in Legal Entity Database?'"
          [closable]="true"
          [style]="{'width': '31.25rem'}"
          (onClose)="onpficLegalEntityDatabaseOK('pfic-entity-db')">
  <div class="form8621-modal-body">
    <p>PFIC Form 8621 prepared by 3rd party should be attached as a PDF</p>
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'OK'" (onClick)="onpficLegalEntityDatabaseOK('pfic-entity-db')"></ap-button>
  </ng-template>
</ap-modal>
}

<ng-template #tooltip1>
  <div class="tooltip-inner ap-p-spacing-3 d-block a-min-width-360">
    <div class="customize-tooltip-text font-weight-normal text-left">
      Who may make the election. A U.S. person that is a shareholder of a corporation that fails to qualify as a qualifying insurance corporation (QIC) (as
      defined in section 1297(f)(1)) solely because its applicable insurance liabilities make up 25% or less of its total assets may elect to treat the stock as
      stock of a qualifying insurance corporation if: 1. The corporations applicable insurance liabilities make up at least 10% of its total assets; and 2.
      Based on the applicable facts and circumstances, the corporation is predominantly engaged in an insurance business, and its failure to satisfy the 25%
      threshold is due solely to runoff-related or rating-related circumstances involving such insurance business. The preamble to the proposed regulations
      provides that until the regulations are published as final, an electing U.S. person may continue to follow the instructions for Form 8621, which require
      the U.S. person to check a box regarding the qualifying insurance corporation exception, and provide the name, address, and taxpayer ID number for the
      foreign corporation. A U.S. person need not complete any other part of Form 8621 if the U.S. person is only filing the form to make the election.
    </div>
  </div>
</ng-template>
